import { render, staticRenderFns } from "./PredepositList.vue?vue&type=template&id=31776040&scoped=true&"
import script from "./PredepositList.vue?vue&type=script&lang=js&"
export * from "./PredepositList.vue?vue&type=script&lang=js&"
import style0 from "./PredepositList.vue?vue&type=style&index=0&id=31776040&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31776040",
  null
  
)

export default component.exports